module.exports = __webpack_public_path__ + "teqbahn-assets/media/TPR.Slidedeck_2.69fc3eda.jpg";